module.exports = "<div class=\"logo-page clearfix section-scrollable\">\n  <div class=\"logo\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"18\" viewBox=\"0 0 40 18\">\n      <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M0 0v7.15h6.667V18h6.666V7.148l13.334.002V18h6.666V7.15H40V0z\"/>\n    </svg>\n  </div>\n  <div class=\"animated fadeInUp\" ng-transclude>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/logoPage/template.html
// module id = 1222
// module chunks = 0